import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { AppBar, Box, Button, CircularProgress, InputLabel, Pagination, Tab, Tabs, TextField } from "@mui/material";
import { Loop } from "@mui/icons-material";
import SelectView from "../../SelectView";
import ButtonDropDown from "../../ButtonDropDown";
import TableComponentView from "../../TableComponentView";
import { Masonry } from "@mui/lab";
import OrderCard from "../OrderCard";
import ButtonDropDown1 from "../../ButtonDropDown1";

const SearchBox = styled(Box)(({ theme }) => ({
  "& input": {
    padding: "12px",
  },
}));


const CustomAppbar = styled(AppBar)(({ theme }) => ({
  backgroundColor: "#fff !important",
  boxShadow: "none !important",
  "& .tab__class": {
    margin: "10px",
    border: "1px solid #1669bb",
    borderRadius: "5px",
    fontWeight: "700"
  },
  "& .Mui-selected": {
    color: "#fff !important",
    background: "#1669bb"
  }
}))


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3, pb: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const InstoreOrderComponent = (props) => {
  return (
    <div>
      <Box
        pb={3}
        display={"flex"}
        flexDirection={props.isMobile ? "column" : "row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Box flex={"1"}>
          <InputLabel>Search</InputLabel>
          <SearchBox display={"flex"}>
            <TextField
              type="search"
              variant="outlined"
              name="searchText"
              value={props.searchText}
              onChange={props.handleChangeSearch}
              // onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={props.handleKeyDown}
              helperText={
                props.searchText ? "Press Enter to search Instore Orders" : ""
              }
              sx={{ width: "300px" }}
            />
          </SearchBox>
        </Box>
        <Box textAlign={"center"} flex="1" sx={{ marginTop: "10px" }}>
          <h2>Warehouse Orders</h2>
        </Box>
        <Box textAlign={"right"} flex="1">
          {props.currOrderNumbers > 0 ? (
            <>
              <b> New Order : {props.currOrderNumbers}</b>
              <Button
                variant="contained"
                color="primary"
                onClick={props.handleRefetch}
                style={{ marginLeft: "10px" }}
              >
                Refetch <Loop fontSize="small" style={{ marginLeft: "5px" }} />
              </Button>
            </>
          ) : (
            ""
          )}
        </Box>
      </Box>

      <CustomAppbar position="static" >
        <Tabs
          orientation={props.isMobile ? "vertical" : "horizontal"}
          value={props.instoreIndex || "instore_order_to_be_printed"}
          onChange={props.handleChangeInstoretab}
          indicatorColor="none"
          // textColor="inherit"
          variant="fullWidth"
          centered
        >
          <Tab label="Order to be printed" value="instore_order_to_be_printed" className="tab__class" />
          <Tab label="Printed Order" value="instore_printed_orders" className="tab__class" />
        </Tabs>
      </CustomAppbar>

      {/* Change View */}
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        mt={2}
      >
        <SelectView handleView={props.handleView} />
        {props.checkedValues.length > 0 ? (
          <Box textAlign={"right"} mb={2} mt={2}>
            <ButtonDropDown1
              checkedValues={props.checkedValues.length}
              handleClickPrint={props.handleMultiplePrint}
            />
          </Box>
        ) : (
          ""
        )}
      </Box>


      <CustomTabPanel value={props.instoreIndex} index={"instore_order_to_be_printed"}>
        {!props.loading ? (
          props.view !== 1 ? (
            <>
              <TableComponentView
                columns={props.columns}
                rows={props.filteredData}
                total={props.total}
                from={props.from}
                to={props.to}
                handleChangePage={props.handleOrderChangePage}
                handleChangeRowsPerPage={props.handleOrderChangeRows}
                rowsPerPage={props.rowsPerPage}
                page={props.page}
                handleViewDetails={props.handleViewDetails}
                handlePickupOrder={props.handlePickupOrder}
                handlePrint={props.handlePrint}
                handleCheck={props.handleCheck}
                checkedValues={props.checkedValues}
                openBackdrop={props.openBackdrop}
                backdropNumber={props.backdropNumber}
              />
            </>
          ) : (
            <>
              <Masonry
                columns={{ xs: 1, sm: 2, md: 3 }}
                spacing={3}
                sx={{ margin: "0", width: "auto" }}
              >
                {props.filteredData &&
                  props.filteredData.map((order) => (
                    <Box key={order.id}>
                      <OrderCard
                        order={order}
                        handlePickupOrder={props.handlePickupOrder}
                        handlePrint={props.handlePrint}
                      />
                    </Box>
                  ))}
              </Masonry>
              {props.filteredData.length ? (
                <Box
                  alignItems={"center"}
                  justifyContent={"center"}
                  display={"flex"}
                >
                  <Pagination
                    size="large"
                    count={props.lastPage}
                    page={props.page}
                    onChange={props.handleOrderChangePage}
                    variant="outlined"
                    shape="rounded"
                    color="primary"
                  />
                </Box>
              ) : (
                ""
              )}
            </>
          )
        ) : (
          <Box textAlign={"center"}>
            <CircularProgress />
          </Box>
        )}
      </CustomTabPanel>

      <CustomTabPanel value={props.instoreIndex} index={"instore_printed_orders"}>
        {!props.loading ? (
          props.view !== 1 ? (
            <>
              <TableComponentView
                columns={props.columns}
                rows={props.filteredData}
                total={props.total}
                from={props.from}
                to={props.to}
                handleChangePage={props.handleOrderChangePage}
                handleChangeRowsPerPage={props.handleOrderChangeRows}
                rowsPerPage={props.rowsPerPage}
                page={props.page}
                handleViewDetails={props.handleViewDetails}
                handlePickupOrder={props.handlePickupOrder}
                handlePrint={props.handlePrint}
                handleCheck={props.handleCheck}
                checkedValues={props.checkedValues}
                openBackdrop={props.openBackdrop}
                backdropNumber={props.backdropNumber}
              />
            </>
          ) : (
            <>
              <Masonry
                columns={{ xs: 1, sm: 2, md: 3 }}
                spacing={3}
                sx={{ margin: "0", width: "auto" }}
              >
                {props.filteredData &&
                  props.filteredData.map((order) => (
                    <Box key={order.id}>
                      <OrderCard
                        order={order}
                        handlePickupOrder={props.handlePickupOrder}
                        handlePrint={props.handlePrint}
                      />
                    </Box>
                  ))}
              </Masonry>
              {props.filteredData.length ? (
                <Box
                  alignItems={"center"}
                  justifyContent={"center"}
                  display={"flex"}
                >
                  <Pagination
                    size="large"
                    count={props.lastPage}
                    page={props.page}
                    onChange={props.handleOrderChangePage}
                    variant="outlined"
                    shape="rounded"
                    color="primary"
                  />
                </Box>
              ) : (
                ""
              )}
            </>
          )
        ) : (
          <Box textAlign={"center"}>
            <CircularProgress />
          </Box>
        )}
      </CustomTabPanel>
    </div>
  );
};

export default InstoreOrderComponent;
